import { createSlice } from '@reduxjs/toolkit'
import { PlansList } from './thunk'

export const initialState = {
    Plans: [],
    loading: true
}
const SetupFee = createSlice({
    name: 'Plans',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Listing
        builder.addCase(PlansList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(PlansList.fulfilled, (state, action) => {
            const { data } = action.payload
            state.Plans = data
            state.loading = false
        })
        builder.addCase(PlansList.rejected, (state) => {
            state.loading = false
        })
    }
})

// export const {} = SetupFee.actions
export default SetupFee.reducer
